import React from "react";
import { Flex } from "@evertrue/et-components";

const ArrowSvg = props => (
  <svg width={221} height={154} {...props}>
    <path
      d="M215.021 13.122c-24.19 50.285-52.823 86.902-85.915 109.833C93.251 147.8 50.501 157.73.9 152.753l.2-1.99c49.144 4.933 91.418-4.887 126.867-29.452 32.773-22.71 61.19-59.048 85.239-109.028l-5.433-2.51L220 0l.482 15.645-5.46-2.523z"
      fill="#EB534B"
    />
  </svg>
);
const ChatTopSvg = props => (
  <svg width="27px" height="27px" viewBox="0 0 27 27" {...props}>
    <path
      d="M2.173 9.12c0-4.065 3.307-7.374 7.374-7.374H21.43c4.064 0 7.374 3.307 7.374 7.373v1.478h-3.568c-4.985 0-9.04 4.056-9.04 9.04v1.934h-7.4c-.413 0-.8.161-1.09.452l-5.534 5.534V9.119z"
      transform="translate(-885 -212) translate(883 123) translate(0 88)"
      fill="#EB534B"
      fillRule="nonzero"
      stroke="none"
      strokeWidth={1}
    />
  </svg>
);
const ChatBottom = props => (
  <svg width="28px" height="26px" viewBox="0 0 28 26" {...props}>
    <path
      d="M30.471 12.266h6.652c4.067 0 7.374 3.307 7.374 7.374v18.438l-5.534-5.534c-.29-.29-.68-.451-1.09-.451l-12.636-.003c-4.065 0-7.374-3.307-7.374-7.374V23.24h3.568c4.985 0 9.04-4.056 9.04-9.04v-1.933z"
      transform="translate(-900 -223) translate(883 123) translate(0 88)"
      fill="#EF8580"
      fillRule="nonzero"
      stroke="none"
      strokeWidth={1}
    />
  </svg>
);
const ChatHomeEmptyState = () => {
  return (
    <Flex alignItems="baseline" className="chat-home--empty">
      <div className="chat-home--empty-copy">
        <div className="chat-home--empty-icons">
          <ChatTopSvg className="chat-home--top-icon" />
          <ChatBottom className="chat-home--bottom-icon" />
        </div>
        <div>It's silent here.</div>
        <div className="chat-home--start-copy">Let's start a chat!</div>
      </div>
      <ArrowSvg />
    </Flex>
  );
};

export default ChatHomeEmptyState;
